import React, {useEffect, useState} from 'react';
import Map3D from "../../components/map3d/Map3D";
import {
    activityFirebaseService, langActivityFirebaseService,
    mapConfigFirebaseService,
    udnFirebaseService,
} from "../../jwt/firebase/firebaseGenericService";
import gpoImage from "../../assets/images/icon/parks/svg/gpoxc-icon.svg";
import {history} from "../../jwt/_helpers";
import Select from "react-select";
import {Label} from "reactstrap";
import {langFirebaseProvider} from "../../providers/gxMaps/langProvider";

const GxMaps = (props) => {

    const udn = { code : props?.match?.params?.code  }
    const lang = { id : props?.match?.params?.langCode }

    const [googleConfig, setGoogleConfig] = useState( null);
    const [udnOptions, setUdnOptions] = useState( [] );
    const [langOptions, setLangOptions] = useState( [] );

    const [activities, setActivities] = useState([]);
    const [markers, setMarkers] = useState([]);

    useEffect(() => {
        return () => {
            console.log('GxMaps unmount');
        }
    }, []);

    useEffect(() => {
        getUdns();
        getLangs();
        getMapConfig(props?.match?.params?.code);
    }, []);

    useEffect(() => {
        getActivities(props?.match?.params?.code, props?.match?.params?.langCode);
    }, []);

    const getUdns = () => {
        let _udns = [];

        udnFirebaseService.getList()
            .then((response) => {
                Object.entries(response).map(([key, value]) => (
                    _udns.push(value)
                ))

                setUdnOptions(_udns);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getLangs = () => {
        langFirebaseProvider.getOptions()
            .then( result => {
                if(result) {
                    setLangOptions(result)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getMapConfig = (udnCode) => {
        mapConfigFirebaseService.getList()
            .then((response) => {
                Object.entries(response).map(([key, value]) => {
                    if (value?.udnCode.toLowerCase() === udnCode.toLowerCase()) {
                        setGoogleConfig({
                            mapOptions: {
                                center: { lat: value?.latitude, lng: value?.longitude },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: value.defaultZoom,
                                gestureHandling: "cooperative",
                                heading: 0,
                                tilt: 0,
                            }
                        })
                    }
                })
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getActivities = (udnCode, langCode) => {
        activityFirebaseService.getList()
            .then((response) => {
                langActivityFirebaseService.getList(langCode)
                    .then((langResponse) => {

                        let activities = [];
                        // Filtra las actividades que pertenecen a udnCode
                        Object.entries(response).map(([key, value]) => {
                            if (!value?.status && value?.status === 0)
                                return;

                            if (value?.udnCode.toLowerCase() === udnCode.toLowerCase()) {
                                let langValue = langResponse[key];
                                let _activity = {...value};

                                _activity.id = key;

                                if(langValue){
                                    _activity.name = langValue.name;
                                    _activity.routeName = langValue.routeName;
                                    _activity.categoryName = langValue.categoryName;
                                }

                                activities.push(_activity);
                            }
                        })

                        setMarkers( mapActivitiesToMarkers(activities) );
                    })
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const mapActivitiesToMarkers = (activities) => {
        let markers = [];

        activities.map((_activity) => {
            const _marker = {
                id: _activity.id,

                name: _activity.name,
                code: _activity.number,
                number: _activity.number,
                routeName: _activity.routeName,
                categoryName: _activity.categoryName,
                aditionalCost: _activity.aditionalCost,

                position: {
                    lat: parseFloat(_activity.lat),
                    lng: parseFloat(_activity.lng)
                }
            }

            markers.push( _marker );
        });

        return markers;
    }


    const notImplemented = () => {
        console.log('Not implemented');
    }

    const redirect = (udnCode, langCode) => {
        history.push("/park/" + udnCode + '/' + langCode);
        window.location.reload();
    }

    return (
        <div >
            <div className={'gxmap-header'}>
                <img className={'gxmap-header-icon'} src={gpoImage} alt={''}/>
                {
                    udnOptions && udnOptions.length > 0 &&
                    udnOptions.map((_udn, index) => {
                        return (
                            <div key={index} className={'gxmap-header-udn'}
                                 onClick={_ => redirect(_udn.code.toLowerCase(), lang.id)}>
                                <span>{'MAPA ' + _udn.name.toUpperCase()}</span>
                            </div>
                        )
                    })
                }
                <div className="float-right">
                    {
                        langOptions && langOptions.length > 0 &&
                        <>
                            <Label >{'Idioma'}</Label>
                            <br/>
                            <Select
                                value={ lang }
                                options={ langOptions }
                                onChange={value => redirect(udn.code.toLowerCase(), value.id)}
                            />
                        </>
                    }
                </div>
            </div>
            {
                googleConfig &&
                <Map3D
                    className="gx-map-container"
                    markers={markers}
                    googleConfig={googleConfig}
                    options={{showRouteMarkers: false, showRoutes: false, showEasyPath: false, show3D: true, udn: udn, showActivities: true}}
                    onTraceClick={notImplemented}
                />
            }
        </div>
    );
}

export default GxMaps;

